var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPositions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 92,
    viewBox: "0 0 96 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.2051 12.2675C93.1992 12.2675 93.1934 12.2667 93.1875 12.2667H67.6875V9.2C67.6875 4.12722 63.9023 0 59.25 0H36.75C32.0977 0 28.3125 4.12722 28.3125 9.2V12.2667H2.8125C1.24658 12.2667 0 13.6658 0 15.3333V82.8C0 87.8728 3.78516 92 8.4375 92H87.5625C92.2148 92 96 87.8728 96 82.8V15.398C96 15.394 96 15.39 96 15.386C95.8923 13.3719 94.7563 12.2786 93.2051 12.2675ZM33.9375 9.2C33.9375 7.50934 35.1995 6.13333 36.75 6.13333H59.25C60.8005 6.13333 62.0625 7.50934 62.0625 9.2V12.2667H33.9375V9.2ZM89.2852 18.4L80.551 46.9695C80.168 48.2241 79.0957 49.0667 77.8835 49.0667H62.0625V46C62.0625 44.3061 60.8035 42.9333 59.25 42.9333H36.75C35.1965 42.9333 33.9375 44.3061 33.9375 46V49.0667H18.1165C16.9043 49.0667 15.832 48.2241 15.449 46.9695L6.71484 18.4H89.2852ZM56.4375 49.0667V55.2H39.5625V49.0667H56.4375ZM90.375 82.8C90.375 84.4907 89.113 85.8667 87.5625 85.8667H8.4375C6.88696 85.8667 5.625 84.4907 5.625 82.8V34.2309L10.1125 48.9093C11.2625 52.6724 14.4792 55.2 18.1165 55.2H33.9375V58.2667C33.9375 59.9605 35.1965 61.3333 36.75 61.3333H59.25C60.8035 61.3333 62.0625 59.9605 62.0625 58.2667V55.2H77.8835C81.5208 55.2 84.7375 52.6724 85.8875 48.9093L90.375 34.2309V82.8Z",
    fill: "#00A094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPositions);
export default __webpack_public_path__ + "static/media/jobPositions.edf0b24a9483b05297c43bdfd0330c68.svg";
export { ForwardRef as ReactComponent };